import axiosInstance from "../../axios/axios";

export const PatientImportApi = async (data) =>
  await axiosInstance.post(`westside/importpatientcsv`, data);
